import { TextField } from '@material-ui/core'
import { StandardTextFieldProps } from '@material-ui/core/TextField'
import { FieldProps } from 'formik'
import React from 'react'

interface IProps extends FieldProps, StandardTextFieldProps {}

export const FormTextField: React.FC<IProps> = ({
  field,
  form,
  children,
  ...props
}) => {
  const isValid = !(form.touched[field.name] && form.errors[field.name])
  return (
    <TextField
      error={!isValid}
      value={field.value || ''}
      onChange={field.onChange}
      onBlur={field.onBlur}
      id={field.name}
      name={field.name}
      {...props}
    />
  )
}
